import React, { useEffect } from 'react'
import { Button, Input, Modal } from '@intelie/ui'

import i18n from 'live/services/i18n'

import { ModalActions, ModalMessage } from '../../styles'
import { Template } from 'plugin-annotations-templates/webapp/src/types'

interface TemplateDeleteModalProps {
    show: boolean
    template: Template
    callbackDelete: (template: Template) => void
    setShow: React.Dispatch<React.SetStateAction<boolean>>
}

const DeleteModal: React.FC<TemplateDeleteModalProps> = ({
    show,
    template,
    callbackDelete,
    setShow
}: TemplateDeleteModalProps) => {
    const [inputText, setInputText] = React.useState('')

    const handleDeleteTemplate = async (): Promise<void> => {
        callbackDelete(template)
    }

    const handleCancel = (): void => {
        setInputText('')
        setShow(false)
    }

    useEffect(() => {
        setInputText('')
    }, [template])

    return (
        <Modal closable size="sm" show={show} onSave={handleDeleteTemplate} onHide={() => handleCancel()}>
            <Modal.Header closeButton title={`${i18n('Warning')}!`} />
            <Modal.Content>
                <ModalMessage>
                    <p>{`${i18n('Are you sure you want to delete this template? This action cannot be undone')}.`}</p>
                    <p>{`${i18n("To delete the template, type 'DELETE' in the field down below")}:`}</p>
                    <Input
                        value={inputText}
                        placeholder={i18n('Type DELETE here to confirm')}
                        onChange={event => {
                            setInputText(event.target.value)
                        }}
                    />
                </ModalMessage>
                <ModalActions>
                    <Button onClick={handleCancel}>{i18n('Cancel')}</Button>
                    <Button
                        className="delete-action"
                        variant="primary"
                        disabled={inputText !== 'DELETE'}
                        onClick={handleDeleteTemplate}
                    >
                        {i18n('Delete template')}
                    </Button>
                </ModalActions>
            </Modal.Content>
        </Modal>
    )
}

export default DeleteModal
